import React from "react";
import Skeleton from "./Skeleton";

const EventItemListLoader = () => {
  return (
    <div className="border border-slate-100 p-3 rounded-lg w-full flex gap-2">
      <div className="w-5 h-5">
        <Skeleton height={"100%"} width={"100%"} />
      </div>
      <div className="h-14 min-w-14 w-14 overflow-hidden rounded-lg border border-gray-200">
        <Skeleton height={"100%"} width={"100%"} />
      </div>
      <div className="space-y-1 h-full flex-grow flex flex-col justify-center">
        <Skeleton height={"12px"} width={"100%"} />
        <Skeleton height={"12px"} width={"100%"} />
      </div>
    </div>
  );
};

export default EventItemListLoader;
